import { useIsPresent, useReducedMotion, type Transition } from 'framer-motion';
import { useMemo } from 'react';

import AnimationsJs from '@dynatrace/strato-design-tokens/animations-js';
import Timings from '@dynatrace/strato-design-tokens/timings-js';

import {
  closeEasing,
  openEasing,
} from '../../../core/utils/framer-motion-easings.js';

export function useOverlayTransition(isChild: boolean): Transition {
  const isPresent = useIsPresent();
  const shouldReduceMotion = useReducedMotion();

  const transition = useMemo(() => {
    let animationTiming = AnimationsJs.Open.Duration.Fast;

    if (!isPresent) {
      animationTiming = isChild
        ? Timings.Offset.Default
        : AnimationsJs.Close.Duration.Base;
    }

    return {
      duration: shouldReduceMotion ? 0 : animationTiming,
      ease: isPresent ? openEasing : closeEasing,
    };
  }, [isPresent, shouldReduceMotion, isChild]);

  return transition;
}

export default useOverlayTransition;
